<div class="container relative flex h-full w-full">
  @if (content && !isEmbed) {
    <img
      class="preview-image"
      [title]="content.fileName"
      [alt]="content.fileName"
      [src]="'/services/image/v1/getPreviewFromSlug/' + slug + '/preview.png'"
      [fallback]="'/assets/types/' + content.type + '.png'"
      [cacheReference]="content.updated_at"
    />
  }

  @if (content && isEmbed) {
    <loading-indicator
      class="fade-out"
      [icon]="icon"
      [circle]="true"
      [colors]="content.typeSpecific.style.colors2"></loading-indicator>
  }

  <div class="logo-overlay center flex pointer-events-none">
    <div class="center flex flex-col">
      <!-- <i class="icon-logo"></i>

      <div class="label">
        powered by 23degrees.io
      </div> -->

      @if (showReload) {
        <div class="reload flex flex-col">
          <!-- <div class="flex flex-col center" *ngIf="loaded"> -->
          <div class="center flex flex-col">
            no interactivity?
            <a [href]="url" target="_self" class="button pointer-events-auto"> Refresh </a>
          </div>
          <!-- <noscript>
          <div class="no-script-text">
            Oh... seems like there is no javascript enabled. Unfortunately we need it to embrace all the beauty of our data visualizations!
          </div>
        </noscript> -->
        </div>
      }
    </div>
  </div>
</div>
